module.exports = __webpack_public_path__ + "img/coin5.c6e678e3.png";